import './features.css';
import featuresImg from './features.png';
import {KeyFeatures} from '../KeyFeatures/KeyFeatures';
import icon1 from './bigIcon1.png';
import icon2 from './bigIcon2.png';
import icon3 from './bigIcon3.png';
import icon4 from './bigIcon4.png';
export const Features = () => {
  return (
    <div id='features'>
      <div className='container'>
          <div className='features-container'>
            <div className='row main-feature'>
                <div className='col-xs-12 col-md-4' data-aos="fade-up">
                    <img src={featuresImg} alt="features" className='main-feature-img'/>
                </div>
                <div className='col-xs-12 col-md-8 features-text' data-aos="fade-up">
                    <h2>RubyRock is a unique NFT</h2>
                    <h3>Blending Real Asset, DeFi tools & Art</h3>
                    <p>
                    RubyRock is an NFT built on Ethereum network with a clear focus on value, efficiency, and transparency. RubyRock combines the value and quality of a traditional asset, with the innovative advantages of blockchain technology, by pegging the NFT to the economic rights of a Ruby Specimen via RBY Token.
                    </p>
                    <br/>
                    <h4><strong>What is RubyRock?</strong></h4>
                    <p>
                        <strong>RubyRock is built on three key foundations:</strong>
                    </p>
                    <ul>
                        <li>An NFT backed by a real asset - Ruby Specimen.</li>
                        <li>A DeFi instrument for passive income, rewards, and a trustworthy medium of exchange.</li>
                        <li>An Art collection of multiple layers (83) and designs representing the Specimen and its source, Tanzania.</li>
                    </ul>
                </div>
            </div>
            <div className='row value-list'>
                <div className='col-xs-12 col-md-3 feature-item' data-aos="fade-up">
                    <img src={icon1} alt="features"/>
                    <h5>1 RubyRock NFT</h5>
                </div>
                <div className='col-xs-12 col-md-3 feature-item' data-aos="fade-up">
                    <img src={icon2} alt="features"/>
                    <h5>1250 RBY Tokens</h5>
                </div>
                <div className='col-xs-12 col-md-3 feature-item' data-aos="fade-up">
                    <img src={icon3} alt="features"/>
                    <h5>0.125 Carats</h5>
                </div>
                <div className='col-xs-12 col-md-3 feature-item' data-aos="fade-up">
                    <img src={icon4} alt="features"/>
                    <h5>$1000</h5>
                </div>
            </div>
            <div className='specs'>
                <span>32,700 carats in total</span>
                <span>327,000,000 RBY Tokens Created</span>
                <span>Pegged by 100% of Ruby Specimen’s economic rights</span>
            </div>

            <KeyFeatures />
          </div>
      </div>
    </div>
  )
}